import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import AdminUserForm from "../../../components/users/AdminUserForm";
import {useCreateUserMutation} from "../../../api/userApiSlice";

function NewUser(props) {
  const history = useHistory();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const { t } = useTranslation();
  const [createUser] = useCreateUserMutation();

  const goToUser = (data) => history.push(`/users/${data.slug}`)

  const handleSubmit = (data) => {
    createUser({user: data}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  return (
    <>
      <Title
        main={t("menu.users")}
        sub={t("new")}
        group={false}
        backPath="/users">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <AdminUserForm handleSubmit={handleSubmit} setSubmitButtonProps={setSubmitButtonProps} />
    </>
  )
}

export default NewUser
